// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XbHGKd{position:relative;height:inherit;display:flex;align-items:stretch;justify-content:center;flex-direction:row-reverse}.oCz8Ju{position:relative;overflow:hidden;height:inherit}.aCeRpc{position:absolute;display:flex}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `XbHGKd`,
	"container": `oCz8Ju`,
	"content": `aCeRpc`
};
export default ___CSS_LOADER_EXPORT___;
